<template>
  <el-row>
    <el-col :xs="24" style="margin: auto;">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :router="true"
        :ellipsis="false"
        text-color="#5F5F5F"
        active-text-color="#552600"
        background-color="#fff"
        @select="handleSelect"
      >
        <el-menu-item index="1" route="/">
          <img
            class="logo"
            src="@/assets/logo1.png"
          />
        </el-menu-item>
        <el-menu-item index="1" route="/">
          <template #title>
            <span>首页</span>
          </template>
        </el-menu-item>
        <el-menu-item index="2" route="/about">
          <template #title>
            <span>关于我们</span>
          </template>
        </el-menu-item>
        <el-menu-item index="3" route="/down">
          <template #title>
            <span>下载APP</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      activeIndex: 1,
      menus: [
        {
          index: 1,
          route: '/'
        },
        {
          index: 2,
          route: '/about'
        },
        {
          index: 3,
          route: '/down'
        }
      ]
    }
  },
  mounted() {
    let path = this.$route.path
    this.activeIndex = this.menus.find(menu => menu.route === location.href.split('#')[1]).index
    console.log('route:',this.$route)
    console.log('path:'+path)
    console.log('path:'+location.href.split('#')[1])
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-menu--horizontal {
  --el-menu-horizontal-height: 60px;
}
.el-menu--horizontal > .el-menu-item:nth-child(1) {
  margin-right: auto;
}
.el-menu--horizontal.el-menu {
  border-bottom: none;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: #fff !important;
}
.el-menu--horizontal>.el-menu-item {
  font-size: 16px;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid transparent !important;
  span {
    border-bottom: 2px solid var(--el-menu-active-color);
    text-box: auto;
    padding: 10px 0 10px 0;
  }
}
.el-menu-demo {
  font-weight: 600;
  font-size: 16px;
}

.logo {
  width: 95px;
}


</style>
